"use client"

import * as React from "react"
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    LabelList,
    Cell,
    Line
} from 'recharts';
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "src/@/components/ui/card"
import {
    ChartContainer,
    ChartLegend,
    ChartLegendContent,
    ChartTooltip,
    ChartTooltipContent,
} from "src/@/components/ui/chart"
import EmptyContentGhost from "src/components/EmptyContentGhost"
import { fShortenNumber } from "src/utils/formatNumber"





  
const chartConfig = {
    total: {
        label: "Conectado",
        color: "#B6A0F7", // Amarelo
    }
};
export function GraficoConversaoLeads({ chartData }) {
    console.log('chartData', chartData);

    const PercentageLabel = ({ x, y, width, value, index }) => {
        // Ocultar a label para o último item ou quando a porcentagem estiver vazia,
        let lastIndex = chartData?.length - 1;
        if (!value || index === lastIndex) return null;
      
        return (
          <foreignObject x={x + width + 10} y={'70%'} width={40} height={24}>
            <div
              style={{
                backgroundColor: "#915B8F",
                color:"#fff",
                fontSize: "10px",
                fontWeight: "bold",
                textAlign: "center",
                borderRadius: "4px",
                padding: "2px 4px",
              }}
            >
              {value ? value.toFixed(0) : 0}%

            </div>
          </foreignObject>
        );
      };

    return (
        <Card className="w-full">
        <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
          <div className="grid flex-1 gap-1 text-center sm:text-left">
            <CardTitle>Conversão de funis</CardTitle>
            <CardDescription>Veja a taxa de conversão dos negócios entre as etapas do funil</CardDescription>
          </div>
        </CardHeader>
        <CardContent>
          {chartData?.length === 0 ? (
            <EmptyContentGhost />
          ) : (
            <ChartContainer className="w-full h-[350px]" config={chartConfig}>
                
              <BarChart
              
                data={chartData}
                margin={{ top: 20, right: 5, left: 5, bottom: 5 }}
              >
                <CartesianGrid  />
                <XAxis dataKey="nome" height={30} interval={chartData.length > 7 ? 1 : 0} />
                {/* <YAxis /> */}
                <Tooltip />
                {/* Barra amarela com valores e porcentagens ao lado */}
                <Line
              dataKey="total"
              type="natural"
              stroke="#f03"
              strokeWidth={2}
              dot={false}
            />

                <Bar
                  dataKey="total"
                  fill="#B6A0F7"
                  barSize={200 / chartData.length }
                  radius={[5, 5, 0, 0]}
                >
                  <LabelList dataKey="total" position="top" fontSize={18} />
                  <LabelList dataKey="porcentagem" content={<PercentageLabel data />} />
                </Bar>
              </BarChart>
            </ChartContainer>
          )}
        </CardContent>
      </Card>
    )
}
